export class CheckIfEventIsInBetslipHelper {
  static checkIfEventIsInBetslip: (
    eventId: number,
    betSlipList: Record<string, any>
  ) => boolean = (eventId: number, betSlipList: Record<string, any>) => {
    let eventInBetslip = false;
    betSlipList &&
      betSlipList.length > 0 &&
      betSlipList.forEach(betSlip => {
        if (betSlip.id === eventId) {
          eventInBetslip = true;
        }
      });
    return eventInBetslip;
  };
}
